import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTGetAPIAuditLogQuery,
	RESTGetAPIAuditLogResult
} from "discord-api-types/v10";





class AuditLogMethods {








	public constructor(public requestHandler: RH) {}





















	public async getAuditLog(guildId: string, options?: RESTGetAPIAuditLogQuery): Promise<RESTGetAPIAuditLogResult> {
		return this.requestHandler.request(Endpoints.GUILD_AUDIT_LOGS(guildId), options, "get", "json");
	}
}

export = AuditLogMethods;
